import { render, staticRenderFns } from "./CoordinateEditor.vue?vue&type=template&id=5d4199a4"
import script from "./CoordinateEditor.vue?vue&type=script&lang=ts"
export * from "./CoordinateEditor.vue?vue&type=script&lang=ts"
import style0 from "./CoordinateEditor.vue?vue&type=style&index=0&id=5d4199a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports